import { Form } from "formik";
import { useMemo } from "react";

import { FormField, FormikForm, type FormFormatMessages } from "../forms";
import { FieldThemePalettePicker } from "./FieldThemePalettePicker";
import { paletteFormatStrings, type PlayerPalette } from "./types";

type FormValues = { palette: PlayerPalette };

interface Props {
  initialValues: FormValues;
  onSubmit: (values: FormValues) => void;
  defaultPalette: PlayerPalette;
  formatStrings?: FormFormatMessages<FormValues>;
}

export const ThemePaletteForm = ({ onSubmit, initialValues, defaultPalette, formatStrings }: Props) => {
  const paletteFormFormatStrings = useMemo(
    () => ({
      ...paletteFormatStrings,
      ...(formatStrings ?? formFormatStrings),
    }),
    [formatStrings],
  );

  return (
    <FormikForm<FormValues>
      initialValues={initialValues}
      onSubmit={onSubmit}
      submitOnBlur
      formatStrings={paletteFormFormatStrings}
      dataTest="palette-form"
    >
      <Form>
        <FormField<FormValues> name="palette">
          <FieldThemePalettePicker defaultPalette={defaultPalette} />
        </FormField>
      </Form>
    </FormikForm>
  );
};

const formFormatStrings = {
  paletteLabel: {
    en: "Palette",
  },
} satisfies FormFormatMessages<FormValues>;
